import React, { useState, useEffect, useMemo } from "react";
import {
  Button,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  IconButton,
  Chip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ScheduleIcon from "@mui/icons-material/Schedule";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import PropTypes from "prop-types";
import axios from "axios";

export default function ActionsMenu({
  row,
  user,
  onOpenCourses,
  onOpenAllottedCourses,
  showSnackbar,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false); // Create/Edit dialog
  const [viewDialogOpen, setViewDialogOpen] = useState(false); // View schedule dialog
  const [yearSemesters, setYearSemesters] = useState([]);
  const [semesters, setSemesters] = useState([]);
  const [admittedBatches, setAdmittedBatches] = useState([]);
  const [slots, setSlots] = useState([]);
  const [errors, setErrors] = useState({});

  const [editingDetail, setEditingDetail] = useState(null);
  const [scheduleDetails, setScheduleDetails] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const menuOpen = Boolean(anchorEl);

  const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleViewDialogClose = () => setViewDialogOpen(false);
  const handleDialogClose = () => setOpenDialog(false);

  return (
    <>
      {/* Main Actions Button */}
      <Button
        variant="contained"
        size="medium"
        startIcon={<MoreVertIcon />}
        sx={{
          backgroundColor: "#1976d2",
          color: "#fff",
          textTransform: "none",
          "&:hover": { backgroundColor: "#115293" },
        }}
        onClick={handleMenuClick}
      >
        Actions
      </Button>

      {/* Actions Menu */}
      <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleMenuClose}>
        <MenuItem
          onClick={() => {
            handleMenuClose();
            onOpenCourses(row);
          }}
          sx={{ color: "blue", "&:hover": { backgroundColor: "rgba(143, 149, 215, 0.65)" } }}
        >
          <EditIcon fontSize="small" style={{ marginRight: 8 }} />
          Assign Courses
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMenuClose();
            onOpenAllottedCourses(row);
          }}
          sx={{
            color: "green",
            "&:hover": { backgroundColor: "rgba(143, 215, 143, 0.65)" },
          }}
        >
          <ScheduleIcon fontSize="small" style={{ marginRight: 8 }} />
          Allotted Courses
        </MenuItem>
      </Menu>

      {/* Create/Edit Dialog */}
    </>
  );
}

ActionsMenu.propTypes = {
  row: PropTypes.object.isRequired,
  user: PropTypes.shape({
    college_id: PropTypes.number.isRequired,
    program_id: PropTypes.number.isRequired,
    client_id: PropTypes.number.isRequired,
    user_email: PropTypes.string.isRequired,
  }).isRequired,
  onOpenCourses: PropTypes.func.isRequired,
  onOpenAllottedCourses: PropTypes.func.isRequired,
  showSnackbar: PropTypes.func.isRequired,
};
